<template>
  <div>
    <div style="display: flex" class="profile-menu d-none d-sm-none d-md-block">
      <!-- <a v-if="IsUserAuthenticated" class="messages">
              <div class="badge">
                <div class="message-count">8</div>
              </div>
            </a> -->
      <ul v-if="IsUserAuthenticated" class="nav navbar-nav">
        <li class="pfl-menu dropdown">
          <a
            href="#"
            style="display: flex; color: white"
            class="dropdown-toggle"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <div class="profile-se">
              <!-- <img
                src="../../public/img/profile_avatar.jpg"
                class="pfl-image caret"
              /> -->
              <i class="ni ni-circle-08"></i>
              <span>
                {{ GetUsername }}
              </span>
            </div>
          </a>
          <ul id="menu-list" class="dropdown-menu">
            <div class="credit-text">
              {{ $t('Profile.walletDeposit') }} : {{ GetSumDeposit | numFormat }}
            </div>
            <div class="credit-text">
              {{ $t('Profile.YourScore') }} : {{ GetCustomerScore | numFormat }}
            </div>
            <div class="credit-text">
              {{ $t('Profile.RialCredit') }} : {{ GetCustomerValueAmount | numFormat }}
            </div>
            <li>
              <router-link to="/profile/dashboard" class="submenu-text"
                >{{ $t('Profilee') }}
              </router-link>
            </li>
            <li><a @click="SignOut()" class="submenu-text"> {{ $t('Footer.SignOut') }} </a></li>
          </ul>
        </li>
      </ul>
    </div>
    <ul id="top_links">
      <li style="padding-right: 10px" v-if="!IsUserAuthenticated">
        <router-link to="/login">{{ $t('HomeHeader.UserEntry') }} </router-link>
      </li>
      <li v-if="!IsUserAuthenticated">
        <router-link to="/register">  {{ $t('Signup') }}  </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
import store from "@/views/profile/store/index";

export default {
  name: "PdkTopline",
  store: store,

  data() {
    return {
      isAuthenticated: false,
      userId: "",
      sources: [],
      topline: [],
      userRoles: [],
      customerClubData: {},
      showintroductionModalCount: 1,
    };
  },

  computed: {
    IsUserAuthenticated() {
      return this.$store.getters.IsUserAuthenticated;
    },
    GetUsername() {
      return this.$store.getters.GetUsername;
    },
    GetSourceName() {
      if (localStorage.getItem("SourceIdInReport") != null)
        return this.$store.getters.GetSourceName;
      else return "";
    },
    GetSumDeposit() {
      if (localStorage.getItem("SourceIdInReport") != null)
        return this.$store.getters.GetSumDeposit;
      else return 0;
    },
    GetSourceDeposit() {
      return this.$store.getters.GetSelectedSourceDeposit;
    },
    GetSourceId() {
      return localStorage.getItem("SourceIdInReport");
    },
    GetCustomerScore() {
      return this.$store.getters.GetCustomerClubData.score;
    },
    GetCustomerValueAmount() {
      return this.$store.getters.GetCustomerClubData.valueAmount;
    },
  },
  created() {
    this.checkForLogin();
    this.getUserId();
    this.checkSources();
  },
  methods: {
    checkForLogin() {
      this.$store.dispatch("checkForLogin");
    },
    SignOut() {
      this.$store.dispatch("signOut").then(() => {
        if (this.$route.name != "main home") this.$router.push("/");
      });
      this.$store.state.customerClubData = {};
      localStorage.clear();
    },
    async getUserId() {
      this.userId = this.$store.getters.GetUserId;
    },
    async checkSources() {
      const isAuthenticated = this.$store.getters.IsUserAuthenticated;
      if (isAuthenticated) {
        this.sources = this.$store.getters.GetAllSourceConfirmed;
        this.customerClubData = this.$store.getters.GetCustomerClubData;

        if (this.sources.length == 0) {
          this.getAllSource();
        }
      }
    },

    async getAllSource() {
      this.$store.dispatch("getAllSourceConfirmed", this.userId).then((res) => {
        this.sources = res;
        // setDefulatSource
        if (this.sources != null) {
          this.$store.dispatch("getDepositInCrs", this.sources[0].id);
        }
      });
    },
  },
};
</script>

<style lang="css" scoped>
.menu {
  margin-top: -3px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
  outline: none;
}
.line {
  fill: none;
  stroke: #fefefe;
  stroke-width: 6;
  transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
    stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
}
.line1 {
  stroke-dasharray: 60 207;
  stroke-width: 6;
}
.line2 {
  stroke-dasharray: 60 60;
  stroke-width: 6;
}
.line3 {
  stroke-dasharray: 60 207;
  stroke-width: 6;
}
.opened .line1 {
  stroke-dasharray: 90 207;
  stroke-dashoffset: -134;
  stroke-width: 6;
}
.opened .line2 {
  stroke-dasharray: 1 60;
  stroke-dashoffset: -30;
  stroke-width: 6;
}
.opened .line3 {
  stroke-dasharray: 90 207;
  stroke-dashoffset: -134;
  stroke-width: 6;
}

.message-count {
  color: #fff;
  font-size: 10px;
  font-family: Arial, san-serif;
  font-weight: bold;
}

.badge {
  position: absolute;
  right: 0px;
  top: -5px;
  z-index: 10;
}

.messages img {
  width: 15px;
  height: auto;
}

.messages {
  width: 29px;
  height: 17px;
  background-image: url(../../public/img/aoXZqPc.gif);
  background-position: 0 0;
  background-repeat: no-repeat;
  display: inline-block;
  vertical-align: top;
  margin-top: 2px;
  position: relative;
}

.badge {
  background: radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background: -moz-radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background: -ms-radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background: -o-radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background: -webkit-radial-gradient(5px -9px, circle, white 8%, #ed2324 26px);
  background-color: #ed2324;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  text-align: center;
  padding: 5% 5%;
  position: relative;
  right: -5.8px;
  top: -9px;
  float: right;
  display: block;
}

.message-count {
  position: relative;
  display: block;
  font-size: 12px;
  /* font: bold 14px/13px Helvetica, Verdana, Tahoma; */
  text-align: center;
  margin: 0;
  top: 2px;
}

#menu-list li {
  border-bottom: #e6e5e8 1px solid;
}
#menu-list li :hover {
  background: #1cd1ed;
}
#menu-list li a {
  color: #444;
}
#menu-list li a:hover {
  color: #ffffff;
}
.profile-title {
  color: white;
}
ul.nav li.dropdown:hover ul.dropdown-menu {
  display: block;
}
.credit-text {
  font-weight: 500;
  color: #00c3e1;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  font-size: 14px;
}

.submenu-text {
  font-size: 14px;
}

.lng-icon {
  width: 30px;
  height: 20px;
}  
.profile-se {
  margin-top: 30px;
}
.profile-se span {
  font-size: 16px;
  font-weight: 500;
  margin-right: 5px;
  color: #444;
}
.pfl-menu {
  margin-top: -3px;
  direction: ltr;
}
.pfl-image {
  border-radius: 50%;
  width: 25px;
  height: 25px;
}

.dropdown-toggle::after {
  display: none !important;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
</style>
<style >
.modal-dialog {
  position: relative;
  width: auto;
  top: 100px !important;
}
</style>